import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BigBuyersModel } from '@/models/tables/big-buyers.model';
import { EsclusioneGrandiAcquirentiModel } from '@/models/tables/ms-discount-model';

@Component({
  selector: 'app-grandi-acquirenti-list',
  template: `
    <div class="grandi-acquirenti-list-container">
      <mat-label class="label-form">{{ label }}:</mat-label>
      <div class="selected-items-list" *ngIf="selectedItems && selectedItems.length > 0">
        <div *ngFor="let item of selectedItems" class="selected-item">
          <span class="item-badge">{{ item.codiceGA }} - {{ item.descrizione }}</span>
        </div>
      </div>
      <div *ngIf="!selectedItems || selectedItems.length === 0" class="no-items">
        <span class="text-gray-400">Nessun grande acquirente selezionato</span>
      </div>
    </div>
  `,
  styles: [
    `
      .grandi-acquirenti-list-container {
        width: 100%;
        margin-top: 0.5rem;
      }

      .selected-items-list {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-top: 0.5rem;
        padding: 0.75rem;
        background-color: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
        min-height: 50px;
      }

      .selected-item {
        display: inline-block;
      }

      .item-badge {
        display: inline-block;
        padding: 0.375rem 0.75rem;
        background-color: rgba(99, 102, 241, 0.2);
        border: 1px solid rgba(99, 102, 241, 0.4);
        border-radius: 4px;
        color: #e5e7eb;
        font-size: 0.875rem;
      }

      .no-items {
        margin-top: 0.5rem;
        padding: 0.75rem;
        text-align: center;
      }
    `,
  ],
})
export class GrandiAcquirentiListComponent implements OnInit, OnChanges {
  @Input() form!: FormGroup;
  @Input() label: string = 'Grandi Acquirenti Selezionati';
  @Input() fieldName: string = 'grandiAcquirenti';

  selectedItems: (BigBuyersModel | EsclusioneGrandiAcquirentiModel)[] = [];

  ngOnInit(): void {
    this.updateSelectedItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['form'] || changes['fieldName']) && this.form) {
      this.updateSelectedItems();
      const actualFieldName = this.getActualFieldName();
      const control = this.form.get(actualFieldName);
      if (control) {
        control.valueChanges.subscribe(() => {
          this.updateSelectedItems();
        });
      }
    }
  }

  private getActualFieldName(): string {
    // If fieldName ends with "Lista", remove it to get the actual form field name
    // e.g., "esclusioneGrandiAcquirentiLista" -> "esclusioneGrandiAcquirenti"
    // e.g., "grandiAcquirentiLista" -> "grandiAcquirenti"
    if (this.fieldName.endsWith('Lista')) {
      return this.fieldName.replace(/Lista$/, '');
    }
    return this.fieldName;
  }

  private updateSelectedItems(): void {
    if (this.form) {
      const actualFieldName = this.getActualFieldName();
      const control = this.form.get(actualFieldName);
      if (control) {
        const value = control.value;
        this.selectedItems = Array.isArray(value) ? value : [];
      }
    }
  }
}
